const Placeholder = ({ children }) => (
  <span className="rounded bg-teal-100 px-1.5 py-0.5 font-semibold text-teal-800">
    {children}
  </span>
);

export const Support = () => (
  <section id="support" className="scroll-mt-20 bg-teal-50/60 py-20">
    <div className="mx-auto max-w-3xl px-5 text-center">
      <p className="text-xs font-extrabold uppercase tracking-widest text-teal-600">
        Support &amp; Kontakt
      </p>
      <h2
        data-testid="support-headline"
        className="font-display mt-3 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl"
      >
        Fragen, Feedback oder Ideen?
      </h2>
      <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
        Wir freuen uns, von dir zu hören – ob Lob, Kritik oder Wünsche für
        die nächste Version von Wokivo.
      </p>
      <p className="mt-6 text-base text-slate-700 sm:text-lg">
        E-Mail:{" "}
        <a
          href="mailto:wokivosocial@gmail.com"
          data-testid="support-email"
          className="font-bold text-teal-600 underline decoration-teal-300 underline-offset-4 transition-colors hover:text-teal-700"
        >
          wokivosocial@gmail.com
        </a>
      </p>
    </div>
  </section>
);

export const ImpressumContent = () => (
  <div data-testid="impressum-content" className="space-y-4 text-sm leading-relaxed text-slate-600">
    <p className="font-bold text-slate-800">Angaben gemäß § 5 DDG</p>
    <p>
      Matthew Woko
      <br />
      Grabenstraße 9
      <br />
      64853 Otzberg
    </p>
    <p>
      <span className="font-bold text-slate-800">Kontakt</span>
      <br />
      E-Mail: wokivosocial@gmail.com
    </p>
    <p>
      <span className="font-bold text-slate-800">
        Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
      </span>
      <br />
      Matthew Woko, Anschrift wie oben
    </p>
  </div>
);

export const DatenschutzContent = () => (
  <div data-testid="datenschutz-content" className="space-y-4 text-sm leading-relaxed text-slate-600">
    <p className="rounded-xl border border-teal-200 bg-teal-50 p-4 text-xs text-teal-800">
      Hinweis: Diese Datenschutzerklärung ist ein Platzhalter und wird noch
      vollständig ergänzt.
    </p>
    <p>
      Diese Website ist ein reines Informationsangebot. Es werden keine
      Cookies gesetzt, kein Tracking eingesetzt und keine personenbezogenen
      Daten durch diese Website erhoben oder gespeichert.
    </p>
    <p>
      Beim Aufruf der Website verarbeitet der Hosting-Anbieter technisch
      notwendige Zugriffsdaten (Server-Logfiles). Details hierzu werden
      ergänzt. <Placeholder>[Platzhalter]</Placeholder>
    </p>
    <p>
      Bei Kontaktaufnahme per E-Mail (wokivosocial@gmail.com) werden die
      angegebenen Daten ausschließlich zur Bearbeitung der Anfrage verwendet.{" "}
      <Placeholder>[Platzhalter]</Placeholder>
    </p>
    <p>
      Eine vollständige Datenschutzerklärung für die Wokivo-App folgt mit dem
      App-Release.
    </p>
  </div>
);
